require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactNative = require("react-native-web/dist/index");

var _platform = require("./../variables/platform");

var _platform2 = _interopRequireDefault(_platform);

var _commonColor = require("./../variables/commonColor");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function () {
  var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _platform2["default"];
  var radioTheme = {
    '.selected': {
      'NativeBase.IconNB': {
        color: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? variables.radioColor : variables.radioSelectedColorAndroid,
        lineHeight: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 25 : variables.radioBtnLineHeight,
        height: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 20 : undefined
      }
    },
    'NativeBase.IconNB': {
      color: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 'transparent' : undefined,
      lineHeight: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? undefined : variables.radioBtnLineHeight,
      fontSize: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? undefined : variables.radioBtnSize
    }
  };
  return radioTheme;
};